export default {
    'home.title'                          : 'Welcome to Spordle Gateway',
    'home.subtitle'                       : 'The official Gateway to Spordle Inc.',
    'home.merchant'                       : 'Gateway Merchant',
    'home.payment'                        : 'Gateway Payment',
    'home.vault'                          : 'Gateway Vault',
}